<nav #dropdownMenuParent (mouseleave)="closeAllDropDowns()" class="top-nav">
  <a (click)="closeAllDropDowns()" [routerLink]="URLS.root" class="brand">
    <h1><img [src]="BRAND.logo.main" alt="logo" class="brand-logo" height="184" width="184" /></h1>
  </a>
  <div class="left-item-wrapper">
    <a (click)="dropdownMenuCompanies.openDropdown(); closeOtherFromCompany()"
      (mouseenter)="dropdownMenuCompanies.openDropdown(); closeOtherFromCompany()">
      <app-company-dropdown #dropdownMenuCompanies [dropdownParent]="dropdownMenuParent" [companies]="COMPANIES">
        <span i18n="@@landingLayoutTopNav.companies">Companies</span>
        <i [class]="'caret fas fa-fw ' + (!dropdownMenuCompanies.isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up')"
          aria-hidden="true">
        </i>
      </app-company-dropdown>
    </a>

    <!-- <a (click)="dropdownMenuProducts.toggleDropdown(); closeOtherDropDowns(dropdownMenuProducts)"
      (mouseenter)="dropdownMenuProducts.openDropdown(); closeOtherDropDowns(dropdownMenuProducts)">
      <app-dropdown-menu #dropdownMenuProducts [dropdownParent]="dropdownMenuParent" [productLines]="PRODUCT_LINES">
        <span i18n="@@landingLayoutTopNav.products">Products</span>
        <i [class]="'caret fas fa-fw ' + (!dropdownMenuProducts.isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up')"
          aria-hidden="true"></i>
      </app-dropdown-menu>
    </a> -->
    <!-- <a (click)="dropdownMenuLibraries.toggleDropdown(); closeOtherDropDowns(dropdownMenuLibraries)"
      (mouseenter)="dropdownMenuLibraries.openDropdown(); closeOtherDropDowns(dropdownMenuLibraries)">
      <app-dropdown-menu #dropdownMenuLibraries [dropdownParent]="dropdownMenuParent" [minimumColumns]="2"
        [productLines]="LIBRARIES">
        <span i18n="@@landingLayoutTopNav.libraries">Libraries</span>
        <i [class]="'caret fas fa-fw ' + (!dropdownMenuLibraries.isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up')"
          aria-hidden="true"></i>
      </app-dropdown-menu>
    </a>
    <a (click)="dropdownMenuPlugins.toggleDropdown(); closeOtherDropDowns(dropdownMenuPlugins)"
      (mouseenter)="dropdownMenuPlugins.openDropdown(); closeOtherDropDowns(dropdownMenuPlugins)">
      <app-dropdown-menu #dropdownMenuPlugins [dropdownParent]="dropdownMenuParent" [minimumColumns]="1"
        [productLines]="PLUGINS">
        <span i18n="@@landingLayoutTopNav.plugins">Plugins</span>
        <i [class]="'caret fas fa-fw ' + (!dropdownMenuPlugins.isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up')"
          aria-hidden="true"></i>
      </app-dropdown-menu>
    </a> -->
    <a class="nav-link" (click)="closeAllDropDowns()" (mouseenter)="closeAllDropDowns()" [routerLink]="URLS.gallery">
      <span i18n="@@landingLayoutTopNav.gallery">Gallery</span>
    </a>
    <a class="nav-link" (click)="closeAllDropDowns()" (mouseenter)="closeAllDropDowns()" [routerLink]="URLS.about">
      <span i18n="@@landingLayoutTopNav.about">About</span>
    </a>
  </div>
  <div class="right-item-wrapper">
    <a (click)="closeAllDropDowns()" (mouseenter)="closeAllDropDowns()" [routerLink]="URLS.contactUs"
      class="startup-portal">
      <i [class]="'fas fa-fw fa-arrow-up-right-from-square'" aria-hidden="true"></i>
      <span i18n="@@landingLayoutTopNav.contactUs">Enquiries</span>
    </a>
  </div>
</nav>